const datesComponentConstants = {
    DATE_FORMAT: 'YYYY-MM-DD',
    ERROR_LABEL: 'error',
    ERROR_MESSAGE: 'La fecha del límite de entrega no puede ser menor a la fecha actual',
    WRONG_DATE: 'Fecha incorrecta'
};

export default datesComponentConstants;